module.exports = __webpack_public_path__ + "static/gavilanwork1-d706a30b516d9cc3bec3b530c4753e67.jpg";